import { themes } from '../services/bff.api';

export const OFFERING_THEMES_RESOURCE = {
  key: 'OFFERING_THEMES_RESOURCE',
  table: {
    defaultSort: 'name',
    dataLocation: '_embedded.themes'
  },
  api: {
    get: themes.getAll
  }
};
